import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

function useTranslationPayments(keyPrefix?: string): TFunction {
  const { t } = useTranslation(Domain.PAYMENTS, { keyPrefix });
  return t;
}

export default useTranslationPayments;
